import { useTranslation } from "react-i18next";
import { DEFAULT_NOTE_DIRECTIONS } from "@/services/api";
import { WidgetControls } from "@/shared/Components";
import type { FC } from "react";

type Props = {
  onChange: (value: string | number) => void;
  defaultValue?: keyof typeof DEFAULT_NOTE_DIRECTIONS;
};

export const CommitmentsControlButtons: FC<Props> = ({ onChange, defaultValue }) => {
  const { t } = useTranslation();

  return (
    <WidgetControls
      defaultValue={defaultValue}
      controls={[
        {
          label: t("notesPage.all"),
          value: DEFAULT_NOTE_DIRECTIONS.ALL,
        },
        {
          label: t("notesPage.incoming"),
          value: DEFAULT_NOTE_DIRECTIONS.INCOMING,
        },
        {
          label: t("notesPage.outgoing"),
          value: DEFAULT_NOTE_DIRECTIONS.OUTGOING,
        },
      ]}
      onChange={onChange}
    />
  );
};
